import type { EnchargeInstance } from "./types";

export type EnchargeBrand = {
  id: EnchargeInstance;
  labelKey: string;
  fallback: string;
};

export const ENCHARGE_BRANDS: EnchargeBrand[] = [
  { id: "gobo-dk", labelKey: "crm.email_lists.brands.gobo_dk", fallback: "Gobo DK" },
  { id: "gobo-se", labelKey: "crm.email_lists.brands.gobo_se", fallback: "Gobo SE" },
  { id: "gobo-fi", labelKey: "crm.email_lists.brands.gobo_fi", fallback: "Gobo FI" },
  {
    id: "gobo-light",
    labelKey: "crm.email_lists.brands.gobo_light",
    fallback: "Gobo Light Solution",
  },
  {
    id: "ljusdesign",
    labelKey: "crm.email_lists.brands.ljusdesign",
    fallback: "Ljusdesign",
  },
];
